/*jshint esversion: 6 */
import PageDisplayer from "./PageDisplayer.js";
import React, { Component } from 'react';
import '../css/utils.css';
import '../css/pageFooter.css';

var PageProxy = (pageObject, pagetitles) => (PageComponent) =>{
   /* return (<PageComponent {...this.props} />);*/
     return class WithAuthorization extends React.Component {
      constructor(props) {
        super(props)
      }

      render() {
        //console.log("PAGE PROXY props", this.props);
        return (<PageComponent pageObject = {pageObject} 
                               pagetitles = {pagetitles}/>);
      }
    } 
  }
  export default PageProxy;


// WEBPACK FOOTER //
// ./src/Components/PageProxy.js